import { render, staticRenderFns } from "./HomeLink.vue?vue&type=template&id=7f61aa9e&scoped=true"
import script from "./HomeLink.vue?vue&type=script&lang=js"
export * from "./HomeLink.vue?vue&type=script&lang=js"
import style0 from "./HomeLink.vue?vue&type=style&index=0&id=7f61aa9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61aa9e",
  null
  
)

export default component.exports